import UserProfile from '../components/profile/UserProfile';

if (document.getElementById('user-profile')) {
    new Vue({
        el: '#user-profile',
        data() {
            return {
                urls: urls,
            }
        },
        components: {
            UserProfile
        },
    });
}


// WEBPACK FOOTER //
// ./resources/js/snippets/profile.js